/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Team_Feat1Inputs */

const en_mk_price_team_feat1 = /** @type {(inputs: Mk_Price_Team_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited divisions & projects`)
};

const id_mk_price_team_feat1 = /** @type {(inputs: Mk_Price_Team_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi & proyek tanpa batas`)
};

/**
* | output |
* | --- |
* | "Unlimited divisions & projects" |
*
* @param {Mk_Price_Team_Feat1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_team_feat1 = /** @type {((inputs?: Mk_Price_Team_Feat1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Team_Feat1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_team_feat1(inputs)
	return en_mk_price_team_feat1(inputs)
});